import { getAxiosConfig, handleApiError } from './risapi'; // Use correct path: ../../../api/risapi
import { risapi } from './risapi'; // Use correct path: ../../../api/risapi

/**
 * Fetches the settings for the currently logged-in franchisee.
 * @param {function} callback - Function to call with the response data { settings: {...} } or error.
 */
export const getFranchiseeSettings = async (callback) => {
    try {
        const response = await risapi.get('/api/franchisee-settings/current', getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // Should contain { settings: { ... } }
        } else {
             console.warn("Unexpected status fetching settings:", response.status, response.data);
             callback({ error: { message: `Unexpected status: ${response.status}` } });
        }
    } catch (error) {
        console.error("API Error in getFranchiseeSettings:", error);
        handleApiError(error); // Log error
        callback({ error }); // Pass error object back
    }
};

/**
 * Updates the franchisee's notification settings.
 * @param {object} settingsData - Object with the toggle values.
 */
export const updateFranchiseeSettings = async (settingsData, callback) => {
    try {
        const response = await risapi.put('/api/franchisee-settings/current', settingsData, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // { settings: {...}, message: "..." }
        }
    } catch (error) {
        // Pass full error back for form validation
        callback({ error });
    }
};

// Add updateFranchiseeSettings function later if needed
/*
export const updateFranchiseeSettings = async (settingsData, callback) => {
    try {
        const response = await risapi.put('/api/franchisee-settings/current', settingsData, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // Contains { settings: {...}, message: '...' }
        } else {
             console.warn("Unexpected status updating settings:", response.status, response.data);
             callback({ error: { response } });
        }
    } catch (error) {
        console.error("API Error in updateFranchiseeSettings:", error);
        callback({ error }); // Let calling component handle validation/other errors
    }
};
*/